import { put, takeLatest } from 'redux-saga/effects';

import {
    requestBrokerUsers,
    requestBrokerUsersFilter,
    requestCreateBrokerUsers,
    requestUpdateBrokerUsers
} from '../../services/broker/brokerUser';
import {
    createBrokerUserFailure,
    createBrokerUserSuccess,
    deleteBrokerUserFailure,
    deleteBrokerUserSuccess,
    fetchBrokerUsersFailure,
    fetchBrokerUsersSuccess,
    updateBrokerUserFailure,
    updateBrokerUserSuccess
} from '../actions/broker/brokerUser';
import {
    CREATE_BROKER_USER_REQUEST,
    DELETE_BROKER_USER_REQUEST,
    FETCH_BROKER_USERS_REQUEST,
    FETCH_FILTER_BROKER_USERS_REQUEST,
    UPDATE_BROKER_USER_REQUEST
} from '../actions/broker/types';

export function* watchBrokerUserSaga() {
    yield takeLatest(FETCH_BROKER_USERS_REQUEST, fetchBrokerUsers);
    yield takeLatest(FETCH_FILTER_BROKER_USERS_REQUEST, fetchBrokerUsersFilter);
    yield takeLatest(CREATE_BROKER_USER_REQUEST, createBrokerUser);
    yield takeLatest(UPDATE_BROKER_USER_REQUEST, updateBrokerUser);
    yield takeLatest(DELETE_BROKER_USER_REQUEST, deleteBrokerUser);
}

/**
 * @typedef {Object} PAYLOAD
 * @property {number} skip
 *
 * @typedef {Object} PARAMS
 * @property {PAYLOAD} payload
 *
 */

/**
 *
 * @param {PARAMS} param0
 */
function* fetchBrokerUsers({ payload }) {
    try {
        const firms = yield requestBrokerUsers(payload);
        yield put(fetchBrokerUsersSuccess(firms));
    } catch (error) {
        yield put(
            fetchBrokerUsersFailure('Failed to get list of broker firms')
        );
    }
}

function* fetchBrokerUsersFilter({ payload }) {
    try {
        const firms = yield requestBrokerUsersFilter(payload);
        yield put(fetchBrokerUsersSuccess(firms));
    } catch (error) {
        yield put(
            fetchBrokerUsersFailure('Failed to get list of broker firms')
        );
    }
}

/**
 *
 * @param {PARAMS} param0
 */
function* createBrokerUser({ payload }) {
    try {
        const response = yield requestCreateBrokerUsers(payload);
        yield put(createBrokerUserSuccess(response.data));
    } catch (error) {
        yield put(
            createBrokerUserFailure('Failed to get list of broker firms')
        );
    }
}

/**
 *
 * @param {PARAMS} param0
 */
function* updateBrokerUser({ payload }) {
    try {
        const response = yield requestUpdateBrokerUsers(payload);
        yield put(updateBrokerUserSuccess(response.data));
    } catch (error) {
        yield put(
            updateBrokerUserFailure('Failed to get list of broker firms')
        );
    }
}

/**
 *
 * @param {PARAMS} param0
 */
function* deleteBrokerUser({ payload }) {
    try {
        const firms = yield deleteBrokerUser(payload);
        yield put(deleteBrokerUserSuccess(firms));
    } catch (error) {
        yield put(
            deleteBrokerUserFailure('Failed to get list of broker firms')
        );
    }
}
